__turbopack_context__.v({
  "a-lehdet": "aNbq3a_a-lehdet",
  "aalto": "aNbq3a_aalto",
  "abb": "aNbq3a_abb",
  "alma": "aNbq3a_alma",
  "dna": "aNbq3a_dna",
  "dsharp": "aNbq3a_dsharp",
  "elisa": "aNbq3a_elisa",
  "enerkey": "aNbq3a_enerkey",
  "finnair": "aNbq3a_finnair",
  "fiskars": "aNbq3a_fiskars",
  "intrum": "aNbq3a_intrum",
  "kesko": "aNbq3a_kesko",
  "kone": "aNbq3a_kone",
  "logo": "aNbq3a_logo",
  "metso": "aNbq3a_metso",
  "nokia": "aNbq3a_nokia",
  "nordea": "aNbq3a_nordea",
  "op": "aNbq3a_op",
  "process-genius": "aNbq3a_process-genius",
  "sap": "aNbq3a_sap",
  "seppo": "aNbq3a_seppo",
  "track": "aNbq3a_track",
  "vr": "aNbq3a_vr",
});
